'use client';

import { useState } from 'react';

import { Carousel, CarouselContent, CarouselItem } from '~/components/ui/carousel/carousel';

import type { EmblaCarouselType } from 'embla-carousel';
import { useTranslations } from 'next-intl';
import { ROUTES } from '~/constants';
import { useDirectSaleOffersControllerGetAllDirectSaleOffers } from '~/lib/api';
import { FinishedSaleCard } from '~/module/home/components/finished-sale-card';
import { SectionTitle } from '~/module/home/components/section-title';

export function HomeFinishedSalesSection() {
  const t = useTranslations('homepage.finished-sales');
  const { data } = useDirectSaleOffersControllerGetAllDirectSaleOffers({
    computedStatus: 'archived',
    limit: 4,
    order: 'ENDED_AT',
  });
  const [, setApi] = useState<EmblaCarouselType | undefined>(undefined);

  if (!data?.data.offers.length) {
    return null;
  }

  return (
    <div className="flex flex-col">
      <SectionTitle href={ROUTES.FINISHED_SALES} title={t('title')} />
      <Carousel
        className="relative w-full"
        images={[]}
        opts={{
          loop: false,
        }}
        plugins={[]}
        setApi={setApi}
      >
        <CarouselContent className="-ml-4">
          {data.data.offers.map((sale) => (
            <CarouselItem key={sale.id} className="pl-4 basis-[50%]">
              <FinishedSaleCard sale={sale} />
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
    </div>
  );
}
